<p
  class="item"
  (click)="navigateToUrl(link)"
  [ngClass]="{ 'loading-shimmer': loadingButton === link }"
>
  {{ text }}
</p>
